import { IList, IResponse, invite } from '@dto';
import { ModuleDefault } from '../default';

export class Read extends ModuleDefault {
  public getMine (params = { page: 1, size: 10 }): Promise<IResponse<IList<invite.IGetMine>>> {
    const queryParams = this.utils.paramSerializer(params);
    return this.request.get<IResponse<IList<invite.IGetMine>>>(`${this.setup.urlBase}/invites${queryParams}`);
  }
}
